import {
  CategoryRewardsPoints,
  CategoryRewardsPointsData,
} from 'src/types/CategoryRewardsPoints'

export function categoriesRewardsPointsMapper(
  categories: CategoryRewardsPointsData[]
): CategoryRewardsPoints[] {
  return categories.map((category) => ({
    slug: category.slug,
    name: category.nome,
    midiasUrls: {
      desktop: category.desktop_midia_url,
      mobile: category.mobile_midia_url,
    },
  }))
}
